import { useEffect, useState } from "react";
import Table from "../../components/admin/Table";
import { studentsData } from "../../assets/studentsData";

export default function UpdateAssesment() {
  const [allStudents, setAllStudents] = useState([]);

  useEffect(() => {
    setAllStudents(studentsData);
  }, []);
  return (
    <>
      <div className="pb-10">
        <Table
          tableTitle={"Update Assessment Marks"}
          data={allStudents}
          setData={setAllStudents}
          columns={[
            "Student Name",
            "Student ID",
            "Marks",
            "Total Marks",
            "Percentage",
            "Action",
          ]}
          forUpdateAssesment={true}
        />
      </div>
    </>
  );
} 